import {Component, OnInit, ViewChild} from '@angular/core';
import {ApiService} from '../../api.service';
import {AvailableTagsComponent} from '../../tags/available-tags/available-tags.component';

@Component({
    selector: 'app-list-files',
    templateUrl: './list-files.component.html',
    styleUrls: ['./list-files.component.css']
})
export class ListFilesComponent implements OnInit {
    @ViewChild(AvailableTagsComponent)
    protected availableTagsComponent: AvailableTagsComponent;
    selectedTags = [];
    loaded = false;
    files;
    filteredFiles;
    sortingOrder = "up";
    currentsorting = "added";
    availableTags: Array<string>;

    constructor(protected apiService: ApiService) {
    }

    ngOnInit() {
        this.getFiles();
        this.getTags();
    }

    getFiles() {
        this.apiService.getAll('files').subscribe(
            (value) => {
                this.loaded = true;
                this.files = value;
                this.files.map((file) => {
                    file.added = new Date(file.added);
                    file.shortname = file.filename;
                    const extension = file.shortname.lastIndexOf('.');
                    if (extension > -1) {
                        let basename = file.filename.substr(0, extension);
                        const ext = file.filename.substr(extension);
                        if (basename.length > 30) {
                            basename = basename.substr(0, 27) + '...';
                        }
                        file.shortname = basename + ext;
                    }

                    return file;
                });
                this.filteredFiles = this.files;
                this.sortBy(this.currentsorting);
            }
        );
    }

    getTags() {
        this.apiService.getTags('files').subscribe((value) => {
            this.availableTags = <Array<string>>value;
        });
    }

    sortBy(attribute: string) {
        if (attribute === this.currentsorting) {
            this.sortingOrder = this.sortingOrder === 'up' ? 'down' : 'up';
        } else {
            this.sortingOrder = 'up';
        }
        this.currentsorting = attribute;

        this.filteredFiles.sort((a, b) => {
            if (this.sortingOrder === 'up') {
                return a[attribute] > b[attribute] ? 1 : -1;
            }
            return b[attribute] > a[attribute] ? 1 : -1;
        });
    }

    toggleTag(obj) {
        const tag = obj.tag;
        if (obj.selected) {
            this.addTag(tag);
        } else {
            this.removeTag(tag);
        }
    }


    addTag(tag) {
        this.selectedTags = this.availableTagsComponent.selectedTags;
        if (this.selectedTags.indexOf(tag) === -1) {
            console.log('adding tag to list of tags');
            this.selectedTags.push(tag);
        }
        this.filterFiles();
    }

    removeTag(tag) {
        this.selectedTags = this.availableTagsComponent.selectedTags;
        this.selectedTags.splice( this.selectedTags.indexOf(tag), 1 );
        this.filterFiles();
    }

    clearSelectedTags() {
        this.selectedTags = [];
        this.filterFiles();
    }
    deleteFile(id) {
        const confirmed = window.confirm('Are you sure?');
        if (confirmed) {
            this.apiService
                .deleteByID('files', id)
                .toPromise()
                .then(
                    () => {
                        this.getFiles();
                        this.getTags();
                    },
                    () => {
                        alert('deletion failed');
                    }
                );
        }
    }

    filterFiles() {
        this.filteredFiles = this.files.filter((file) => {
            if (this.selectedTags.length === 0) {
                return true;
            }
            const intersection = file.tags.filter((tag) => {
                return -1 !== this.selectedTags.indexOf(tag);
            });
            return intersection.length > 0;
        });
    }

    setTagSelection(selectedTags) {
        this.selectedTags = selectedTags;
        this.filterFiles();
    }
}



// WEBPACK FOOTER //
// ./src/app/files/list-files/list-files.component.ts